import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface BookingCardVoucherButtonProps {
  isEnabled: boolean
  onClick?: () => void
}

export const BookingCardVoucherButton = ({
  isEnabled,
  onClick,
}: BookingCardVoucherButtonProps) => {
  const { t } = useTranslation()

  return (
    <button
      type="button"
      className={clsx(s.button, { [s.disabled]: !isEnabled })}
      onClick={onClick}
      disabled={!isEnabled}
    >
      <span className={clsx('bold-14', s.text)}>
        {t('kyrgyzstan_block.booking_card.show_voucher')}
      </span>
      <AppIcon
        id={AllIcons.CHEVRON_RIGHT}
        width={12}
        height={12}
        className={s.icon}
      />
    </button>
  )
}
